import axios from "axios";
import AxiosAPI from "./AxiosAPI";



export const fetchAllCustomers = async () => {
  try {
    const response = await AxiosAPI.get("crm/customers?isDeleted=false&size=1000");
    return response.data;
  } catch (error) {
    console.log(error, "while fetching the customers")
    throw error.response?.data || error;
  }
};


// export const fetchCustomers = async (
//   from = 0,
//   size = 100,
//   isDeleted, // Default value set to false
//   customerDetails = null,
//   phoneNo = null,
//   emailID = null,
//   city = null,
//   state = null,
//   postalCode = null,
//   country = null,
//   membershipName = null,
//   segment = null,
//   customField1 = null,
//    isExport, 
//       pitId,
//       searchAfter 
// ) => {
//   try {
//     let apiUrl = `/crm/customers`;
//     let queryParams = [];

    

//     // Only include from/size if NO filters are active AND isDeleted is false
//     // if (!hasActiveFilters && !isDeleted) {
//     //   if (from !== null && from !== undefined) {
//     //     queryParams.push(`from=${from}`);
//     //   }
//     //   if (size !== null && size !== undefined) {
//     //     queryParams.push(`size=${size}`);
//     //   }
//     // }

//     // Always include isDeleted parameter with false as default
//     if(isDeleted!==null) {
//  queryParams.push(`isDeleted=${isDeleted}`);
//     }
   
//     if (from) {
//       queryParams.push(`from=${(from)}`);
//     }
//      if (isExport) {
//       queryParams.push(`isExport=${(isExport)}`);
//     }
//       if (pitId) {
//       queryParams.push(`pitId=${(pitId)}`);
//     }
//       if (searchAfter) {
//       queryParams.push(`searchAfter=${(searchAfter)}`);
//     }
    
//     if (size) {
//       queryParams.push(`size=${(size)}`);
//     }
//     // Add other parameters if they exist
//     if (customerDetails) {
//       queryParams.push(`customerDetails=${(customerDetails)}`);
//     }
//     if (phoneNo) {
//       queryParams.push(`phoneNo=${(phoneNo)}`);
//     }
//     if (emailID) {
//       queryParams.push(`emailID=${(emailID)}`);
//     }
//     if (city) {
//       queryParams.push(`city=${(city)}`);
//     }
//     if (state) {
//       queryParams.push(`state=${(state)}`);
//     }
//     if (postalCode) {
//       queryParams.push(`postalCode=${(postalCode)}`);
//     }
//     if (country) {
//       queryParams.push(`country=${(country)}`);
//     }
//     if (membershipName) {
//       queryParams.push(`membershipName=${(membershipName)}`);
//     }
//     if (segment) {
//       queryParams.push(`segment=${(segment)}`);
//     }
//     if (customField1) {
//       queryParams.push(`customField1=${(customField1)}`);
//     }

//     apiUrl += queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

//     const response = await AxiosAPI.get(apiUrl);
//     return response.data;
//   } catch (err) {
//     console.error('Error fetching customers:', err);
//     throw err;
//   }
// };
export const fetchCustomers = async (
  from = 0,
  size = 100,
  isDeleted, // Default value set to false
  customerDetails = null,
  phoneNo = null,
  emailID = null,
  city = null,
  state = null,
  postalCode = null,
  country = null,
  membershipName = null,
  customField1 = null,
   isExport, 
      pitId,
      searchAfter,
      segment = null, 
      wallet,
      isGetCustomerSpentAmountAndNoOfVisit=false,
) => {
  try {
    let apiUrl = `/crm/customers`;
    let queryParams = [];

    

    // Only include from/size if NO filters are active AND isDeleted is false
    // if (!hasActiveFilters && !isDeleted) {
    //   if (from !== null && from !== undefined) {
    //     queryParams.push(`from=${from}`);
    //   }
    //   if (size !== null && size !== undefined) {
    //     queryParams.push(`size=${size}`);
    //   }
    // }

    // Always include isDeleted parameter with false as default
    if(isDeleted!==null) {
 queryParams.push(`isDeleted=${isDeleted}`);
    }

     if(isGetCustomerSpentAmountAndNoOfVisit!==null) {
 queryParams.push(`isGetCustomerSpentAmountAndNoOfVisit=${isGetCustomerSpentAmountAndNoOfVisit}`);
    }

    
   
    if (from) {
      queryParams.push(`from=${(from)}`);
    }
     if (isExport) {
      queryParams.push(`isExport=${(isExport)}`);
    }
      if (pitId) {
      queryParams.push(`pitId=${(pitId)}`);
    }
      if (searchAfter) {
      queryParams.push(`searchAfter=${(searchAfter)}`);
    }
    
    if (size) {
      queryParams.push(`size=${(size)}`);
    }
    // Add other parameters if they exist
    if (customerDetails) {
      queryParams.push(`customerDetails=${(customerDetails)}`);
    }
      if (segment) {
      queryParams.push(`segment=${(segment)}`);
    }
     if (wallet) {
      queryParams.push(`wallet=${(wallet)}`);
    }
    if (phoneNo) {
      queryParams.push(`phoneNo=${(phoneNo)}`);
    }
    if (emailID) {
      queryParams.push(`emailID=${(emailID)}`);
    }
    if (city) {
      queryParams.push(`city=${(city)}`);
    }
    if (state) {
      queryParams.push(`state=${(state)}`);
    }
    if (postalCode) {
      queryParams.push(`postalCode=${(postalCode)}`);
    }
    if (country) {
      queryParams.push(`country=${(country)}`);
    }
    if (membershipName) {
      queryParams.push(`membershipName=${(membershipName)}`);
    }
    if (customField1) {
      queryParams.push(`customField1=${(customField1)}`);
    }

    apiUrl += queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

    const response = await AxiosAPI.get(apiUrl);
    return response.data;
  } catch (err) {
    console.error('Error fetching customers:', err);
    throw err;
  }
};

export const fetchCustomerByMobileNos = async (mobileNos) => {
  try {
    const response = await AxiosAPI.get(`/crm/getcustomerbymobilenos?mobileNos=${mobileNos}`);
    return response.data;
  } catch (err) {
    throw err.response?.data || err;
  }
};




export const handleAddCustomer = async (data) => {
  try {
    const response = await AxiosAPI.post("/crm/customers/", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
};

export const handleEditCustomer = async (key,data) => {
  try {
    const response = await AxiosAPI.put(
      `/crm/customers/${key}`,
      data, {
      headers: {
        "Content-Type": "application/json",
      },
    }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
export const fetchSearchCustomers = async (search) => {
  try {
    // Determine the query parameter based on the input type
    let queryParam;
    if (!isNaN(search)) {
      queryParam = `phoneNo=${search}`;
    } else {
      queryParam = `customerDetails=${search.toLowerCase()}`;
    }

    // Make the API request with the combined query parameters
    const response = await AxiosAPI.get(
      `/crm/customers?isDeleted=false&${queryParam}`
    );
    console.log(response);

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteCustomer = async (key) => {
  try {
    const response = await AxiosAPI.delete(`/crm/customers/${key}`);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};



export const getCustomerDashboardHeaders = async (customerID) => {
  try {
    const response = await AxiosAPI.get(
      `/crm/customers/dashboardhraders/${customerID}`
    );
    console.log(response);

    return response.data; // Make sure to return the data
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCustomerDetails = async (customerID) => {
  try {
    const response = await AxiosAPI.get(
      `/crm/customers/customerdetails/${customerID}`
    );
    console.log(response);

    return response.data; // Make sure to return the data
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCustomerTransactions = async (customerID) => {
  try {
    const response = await AxiosAPI.get(
      `/crm/customers/transaction/${customerID}`
    );
    console.log(response);

    return response.data; // Make sure to return the data
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCustomerProducts = async (customerID, size) => {
  try {
    const params = {}
    if (size) {
      params.size = size;
    }
    const response = await AxiosAPI.get(
      `/crm/customers/customerproducts/${customerID}`, { params }
    );
    console.log(response);

    return response.data; // Make sure to return the data
  } catch (err) {
    console.log(err);
    throw err;
  }
};



export const getCustomerPackages = async (customerID) => {
  try {
    const response = await AxiosAPI.get(
      `/crm/customers/customerpackages/${customerID}`
    );
    console.log(response);

    return response.data; // Make sure to return the data
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getLoyaltyLedgersByCustomerID = async (customerID) => {

  try {
    const response = await AxiosAPI.get(
      `/crm/customers/loyaltyledges/${customerID}`
    );
    console.log(response);

    return response.data; // Make sure to return the data
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getUpcomingAppointmentsForCustomer = async (customerID) => {

  try {
    const response = await AxiosAPI.get(
      `/crm/customers/upcomingappoinment/${customerID}`
    );
    console.log(response);

    return response.data; // Make sure to return the data
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getPastAppointmentsForCustomer = async (customerID) => {

  try {
    const response = await AxiosAPI.get(
      `/crm/customers/pastappoinmet/${customerID}`
    );
    console.log(response);

    return response.data; // Make sure to return the data
  } catch (err) {
    console.log(err);
    throw err;
  }
};



export const getCustomerLoyaltyPoints = async (customerId) => {

  try {
    const response = await AxiosAPI.get(
      `/getloyaltycustomer/${customerId}`
    );
    console.log(response);

    return response.data; // Make sure to return the data
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getEasyRewardWorkflowWidget = async (
  registrationID, 
    storeCode, 
    customerMobileNo) => {

  try {
    const response = await axios
    .post(
      "https://us-central1-posible-app-prod.cloudfunctions.net/apiGetEasyRewardWorkflowWidget",
      {
       RegistrationID:registrationID, 
                StoreCode:storeCode,
                CustomerMobileNo:customerMobileNo,
      }
    )

    return response.data; // Make sure to return the data
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const getCustomerMLoyalLoyaltyPoints = async ( registrationID,
  storeID,
  customerID,
  customerMobileNo) => {

  try {
    const response = await axios
    .post(
      "https://us-central1-posible-app-prod.cloudfunctions.net/apiGetMLoyalCustomerLoyaltyPoints",
      {
        RegistrationID: registrationID,
        StoreID: storeID,
        CustomerID: customerID,
        CustomerMobileNo: customerMobileNo,
      }
    )

    return response.data; // Make sure to return the data
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCustomerEasyRewardzLoyaltyPoints = async (
   registrationID, 
    storeID, 
    storeCode, 
    customerID, 
    customerMobileNo) => {

  try {
    const response = await axios
    .post(
      'https://us-central1-posible-app-prod.cloudfunctions.net/apiGetCustomerEasyRewardzLoyaltyPoints',
      {
        RegistrationID:registrationID, 
                StoreID:storeID,
                StoreCode:storeCode,
                CustomerID:customerID, 
                CustomerMobileNo:customerMobileNo,
      }
    )

    return response.data; // Make sure to return the data
  } catch (err) {
    console.log(err);
    throw err;
  }
};

//this is fetching packages pending and partials
export const getPackagesByCustomerID = async (customerID) => {
  try {
    const response = await AxiosAPI.get(
      `/crm/customers/getpackagesbycustomerid/${customerID}`
    );
    console.log(response);

    return response.data; // Make sure to return the data
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const fetchCustomerAudittrails = async (key) => {
  try {
    const response = await AxiosAPI.get(
      // `/crm/customers/audittrails/${key}`
       `/crm/customer/audittrails/${key}`
    );

    return response.data; // Make sure to return the data
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const getWalletLedgersByCustomerID = async (from,size,customerID,registrationID,searchTransactionFromDate,searchTransactionToDate,searchTransactionNo) => {
  try {
    const params={
         customerID:customerID, // Added missing customerID parameter
      registrationID:registrationID,
      searchTransactionToDate:searchTransactionToDate,
      searchTransactionFromDate:searchTransactionFromDate,
      searchTransactionNo:searchTransactionNo,
      from:from,
      size:size,
    }
    const response = await AxiosAPI.get(
      `/crm/customers/walletledges`,{params}
    );

    return response.data; // Make sure to return the data
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const fetchOutStandingLedgerByCustomerID = async (from,size,customerID,registrationID,searchTransactionFromDate,searchTransactionToDate,searchTransactionNo) => {
  try {
    const params={
         customerID:customerID, // Added missing customerID parameter
      registrationID:registrationID,
      searchTransactionToDate:searchTransactionToDate,
      searchTransactionFromDate:searchTransactionFromDate,
      searchTransactionNo:searchTransactionNo,
      from:from,
      size:size,
    }
    const response = await AxiosAPI.get(
      `/reports/customer/outstandingledgerbycustomerid`,{params}
    );

    return response.data; // Make sure to return the data
  } catch (err) {
    console.log(err);
    throw err;
  }
};


